<div class="container modal-container p-3">
    <div class="row px-3">
      <h4
        class="text-start text-color-theme font-type"
        [innerHTML]="data?.item?.ShortDesc"
      ></h4>
    </div>
    <div class="row px-3">
      <p
        class="text-color-theme font-type"
        [innerHTML]="sanitizer.bypassSecurityTrustHtml(data?.item?.Desc)"
      ></p>
    </div>
  </div>
  